// 后台工作状态不参与可输入判断；只有入口关闭/项目停用才改为只读。
export function projectConversationWritable({ workspaceEnabled, projectStatus }) {
  return workspaceEnabled === true && projectStatus === 'active'
}
export const projectGateActionable = payload => payload?.status === 'pending' && Boolean(payload.gate?.id) && Number(payload.gate?.version) > 0
  && (payload.gate.kind !== 'media' || (payload.gate.media?.kind === 'digitalHuman' && payload.gate.media.state === 'selection')
    || (payload.gate.media?.state === 'quoted' && typeof payload.gate.media.points === 'number'
      && Number.isFinite(payload.gate.media.points) && payload.gate.media.points >= 0))
export function buildProjectCommand(projectGuid, run, kind, clientRequestId) {
  if (!run.runGuid || !Number.isInteger(run.planVersion) || run.planVersion < 1 || !Number.isInteger(run.stateVersion) || run.stateVersion < 1)
    throw new Error('工作状态不完整，请刷新后操作')
  return { projectGuid, runGuid: run.runGuid, expectedPlanVersion: run.planVersion, expectedStateVersion: run.stateVersion, kind, clientRequestId }
}

// 主对话消息原位更新：游标补读可能重复，也可能晚于另一轮刷新返回。
export function mergeProjectMessages(current = [], incoming = []) {
  const messages = new Map(current.map(item => [item.messageGuid, item]))
  for (const item of incoming) {
    if (!item || typeof item.messageGuid !== 'string' || !Number.isFinite(Number(item.seq))) continue
    const old = messages.get(item.messageGuid)
    if (!old || Number(item.messageVersion || 1) >= Number(old.messageVersion || 1)) messages.set(item.messageGuid, item)
  }
  return [...messages.values()].sort((a, b) => Number(a.seq) - Number(b.seq))
}

// chat 缺省时保持旧指纹；显式后台规划必须成为幂等请求的一部分。
export function buildProjectSendContext({ content, planFirst, targetTaskGuid, targetAssetRef, mode = 'chat' }) {
  if (!['chat', 'background_plan'].includes(mode)) throw new Error('发送方式无效，请重新选择')
  return { content, planFirst, ...(targetTaskGuid ? { targetTaskGuid } : {}), ...(targetAssetRef ? { targetAssetRef } : {}),
    ...(mode === 'background_plan' ? { mode } : {}) }
}

const statusLabel = (labels, status, fallback = '') => typeof status === 'string' && Object.prototype.hasOwnProperty.call(labels, status) ? labels[status] : fallback

export function projectTaskStatusLabel(status) {
  return statusLabel({ queued: '排队中', running: '执行中', waiting_input: '待补充信息', waiting_approval: '待审批', waiting_plan: '待确认计划',
    paused_plan: '计划已暂停', succeeded: '已完成', failed: '执行失败', cancelled: '已停止', pending: '待执行', completed: '已完成',
    awaiting_approval: '待确认' }, status, '状态待确认')
}

export function projectConversationMessageStatus(message) {
  if (message?.status === 'planning') return '已交给团队，正在排队或后台规划'
  if (message?.kind === 'progress' && message.payload?.mode === 'background_plan') return statusLabel({
    queued: '后台规划排队中', generating: '团队正在后台规划', completed: '后台规划已完成，请查看计划', failed: '后台规划失败，请查看失败说明'
  }, message.payload.status)
  if (message?.role !== 'user') return ''
  return statusLabel({ queued: '消息已排队，等待主管回复', generating: '主管正在回复这条消息' }, message.status)
}

// 状态区只展示公开事实；文件必须有已保存的资产引用，模型文字不能变成下载链接。
export function projectConversationProgress(snapshot) {
  const list = value => Array.isArray(value) ? value : []
  const text = value => typeof value === 'string' ? value : ''
  return { observedAt: Number(snapshot?.observedAt) || 0, projectGuid: text(snapshot?.projectGuid),
    tasks: list(snapshot?.tasks).filter(task => task && text(task.taskGuid)).map(task => ({
      taskGuid: task.taskGuid, latestRunGuid: text(task.latestRunGuid), title: text(task.title), runStatus: text(task.runStatus || task.status),
      stepSummary: list(task.stepSummary).filter(Boolean).map(step => ({ stepId: text(step.stepId), title: text(step.title), status: text(step.status) })),
      pendingDecision: task.pendingDecision && typeof task.pendingDecision === 'object' ? {
        id: text(task.pendingDecision.id), version: task.pendingDecision.version, kind: text(task.pendingDecision.kind),
        question: text(task.pendingDecision.question), planVersion: task.pendingDecision.planVersion
      } : null,
      finalAssets: list(task.finalAssets).filter(file => file && text(file.assetGuid) && Number.isInteger(file.version) && file.version > 0)
        .map(file => ({ assetGuid: file.assetGuid, version: file.version, displayName: text(file.displayName), mimeType: text(file.mimeType) })),
      workSource: task.workSource ? { kind: text(task.workSource.kind), taskTitle: text(task.workSource.taskTitle),
        triggeredAt: task.workSource.triggeredAt, timezone: text(task.workSource.timezone), automationGuid: text(task.workSource.automationGuid),
        automationName: text(task.workSource.automationName), fireGuid: text(task.workSource.fireGuid) } : null
    })),
    planning: list(snapshot?.planning).filter(item => item && text(item.messageGuid)).map(item => ({
      messageGuid: item.messageGuid, status: text(item.status), attempts: item.attempts, createTime: item.createTime
    })) }
}
